import useAuthGuard, { AUTH_GUARD_PRIVATE } from './useAuthGuard';

export default function usePrivateRoute() {
  return useAuthGuard() === AUTH_GUARD_PRIVATE;
}
